import {
  CreateUserKpiBodySchema,
  UpdateUserKpiBodySchema,
  ReorderUserKpisBodySchema,
  UserKpiEntrySchema,
  UserKpiListResponseSchema,
  type CreateUserKpiBody,
  type UpdateUserKpiBody,
  type UserKpiEntry,
} from "@nexus/contracts";
import { authFetch } from "@/lib/api-client";

/** The two page domains that own per-user KPI settings routes. */
export type UserKpiScope = "overview" | "drilldown";

export async function fetchUserKpis(scope: UserKpiScope): Promise<UserKpiEntry[]> {
  const { data } = await authFetch<UserKpiEntry[]>(`/${scope}/user-kpis`);
  return UserKpiListResponseSchema.parse(data);
}

export async function createUserKpi(
  scope: UserKpiScope,
  body: CreateUserKpiBody,
): Promise<UserKpiEntry> {
  const payload = CreateUserKpiBodySchema.parse(body);
  const { data } = await authFetch<UserKpiEntry>(`/${scope}/user-kpis`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return UserKpiEntrySchema.parse(data);
}

export async function updateUserKpi(
  scope: UserKpiScope,
  id: number,
  body: UpdateUserKpiBody,
): Promise<UserKpiEntry> {
  const payload = UpdateUserKpiBodySchema.parse(body);
  const { data } = await authFetch<UserKpiEntry>(`/${scope}/user-kpis/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
  return UserKpiEntrySchema.parse(data);
}

/** Deletes the caller's own KPI, or resets an override back to the org definition. */
export async function deleteUserKpi(scope: UserKpiScope, id: number): Promise<void> {
  await authFetch(`/${scope}/user-kpis/${id}`, { method: "DELETE" });
}

export async function reorderUserKpis(
  scope: UserKpiScope,
  names: string[],
): Promise<UserKpiEntry[]> {
  const payload = ReorderUserKpisBodySchema.parse({ names });
  const { data } = await authFetch<UserKpiEntry[]>(`/${scope}/user-kpis/order`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return UserKpiListResponseSchema.parse(data);
}

export async function shareUserKpiWithOrg(
  scope: UserKpiScope,
  id: number,
): Promise<UserKpiEntry> {
  const { data } = await authFetch<UserKpiEntry>(`/${scope}/user-kpis/${id}/share`, {
    method: "POST",
    body: JSON.stringify({}),
  });
  return UserKpiEntrySchema.parse(data);
}
